import { Injectable, inject } from '@angular/core';
import { combineLatest, map, shareReplay } from 'rxjs';
import { Plugin } from '@jeppesen-foreflight/jmkw-types';
import { FlightRulesPluginService } from './flight-rules/flight-rules.plugin.service';
import { HighIceWaterPluginService } from './high-ice-water/high-ice-water.plugin.service';
import { HighLevelSignificantPluginService } from './high-level-significant/high-level-significant.plugin.service';
import { IcingPluginService } from './icing/icing.plugin.service';
import { SeaSurfaceTemperaturePluginService } from './sea-surface-temperature/sea-surface-temperature.plugin.service';
import { SurfacePluginService } from './surface/surface.plugin.service';
import { TAFsPluginService } from './tafs/tafs.plugin.service';
import { TempsWindsAloftPluginService } from './temps-winds-aloft/temps-winds-aloft.plugin.service';
import { TurbulencePluginService } from './turbulence/turbulence.plugin.service';
import { WaveHeightPluginService } from './wave-height/wave-height.plugin.service';
import { WinterRadarReflectivityPluginService } from './winter-radar-reflectivity/winter-radar-reflectivity.plugin.service';

@Injectable({
  providedIn: 'root'
})
export class TwcForecastPluginService {
  icingPlugin$ = inject(IcingPluginService).plugin$;
  tempsWindsAloftPlugin$ = inject(TempsWindsAloftPluginService).plugin$;
  TAFs$ = inject(TAFsPluginService).plugin$;
  turbulence$ = inject(TurbulencePluginService).plugin$;
  waveHeight$ = inject(WaveHeightPluginService).plugin$;
  flightRules$ = inject(FlightRulesPluginService).plugin$;
  seaSurfaceTemperature$ = inject(SeaSurfaceTemperaturePluginService).plugin$;
  surface$ = inject(SurfacePluginService).plugin$;
  highIceWater$ = inject(HighIceWaterPluginService).plugin$;
  winterRadarReflectivity$ = inject(WinterRadarReflectivityPluginService)
    .plugin$;

  highLevelSignificant$ = inject(HighLevelSignificantPluginService).plugin$;

  plugin$ = combineLatest([
    this.highLevelSignificant$,
    this.seaSurfaceTemperature$,
    this.surface$,
    this.icingPlugin$,
    this.tempsWindsAloftPlugin$,
    this.turbulence$,
    this.waveHeight$,
    this.flightRules$,
    this.highIceWater$,
    this.TAFs$,
    this.winterRadarReflectivity$
  ]).pipe(
    map(
      (twcPlugins) =>
        new Plugin({
          id: 'forecast',
          children: twcPlugins
        })
    ),
    shareReplay(1)
  );
}
